<template>
    <div class="page-editor">


        <div v-for="(field, key) in pageData" :key="key" class="form-group">
          <div v-if="formatFieldName(key) !=='Page_name'">

            <label :for="key">{{ formatFieldName(key) }}</label>

            <component
              :token="token"
              :setLoading="setLoading"
              :is="getFieldComponent(field.type)"
              :field-data="field"
              :field-key="key"
              @update-field="updateField"
              @notice="$emit('notice', $event)"
            ></component>

          </div>
        </div>

    </div>
  </template>
  
  <script>
    
    import TextFieldEditor from './fields/TextFieldEditor.vue';
    import ImageFieldEditor from './fields/ImageFieldEditor.vue';
    import ButtonFieldEditor from './fields/ButtonFieldEditor.vue';
    import FaqEditor from './fields/FaqEditor.vue';
    import ServicesEditor from './fields/ServicesEditor.vue';
    import AvailableCurrenciesEditor from './fields/AvailableCurrenciesEditor.vue';
    import DeviseRateEditor from './fields/DeviseRateEditor.vue';
    import DeviseVisibilityEditor from './fields/DeviseVisibilityEditor.vue';
    import UserProfil from './fields/UserProfil.vue';
    import PopupsConfig from './fields/PopupsConfig.vue';
    
    export default {
      name: 'PageEditor',
      props: {
        page: {
          type: String,
          required: true,
        },
        setLoading: Function,
        token: String
      },
      data() {
        return {
          pageData: {},
          originalData: {},
          saveActive: true
        };
      },
      computed: {
        pageTitle() {
          return this.page.charAt(0).toUpperCase() + this.page.slice(1).replace(/([A-Z])/g, ' $1');
        },
      },
      watch: {
        page: {
          handler(newPage) {
            const pageContent = { ...this.$parent.pages[newPage] };
            this.pageData = JSON.parse(JSON.stringify(pageContent)); // Deep copy
            this.originalData = JSON.parse(JSON.stringify(pageContent)); // Save original for reset
          },
          immediate: true,
        },
      },
      methods: {
        getFieldComponent(type) {
          const components = {
            services: ServicesEditor,
            text: TextFieldEditor,
            image: ImageFieldEditor,
            button: ButtonFieldEditor,
            faq: FaqEditor,
            currencies: AvailableCurrenciesEditor,
            currencyRates: DeviseRateEditor,
            currencyVisibility: DeviseVisibilityEditor,
            profil: UserProfil,
            popups: PopupsConfig
          };
          return components[type] || 'div'; // Default to 'div' if no match
        },
        updateField({ key, fieldName, value }) {
          if (this.pageData[key]) {
            if (fieldName === null) {
              this.pageData[key] = value;
              this.$emit('save', this.pageData);
              return;
            }
            this.pageData[key][fieldName] = value; // Update specific field
          }
        },
        formatFieldName(fieldName) {
          return fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
        },
        resetChanges() {
          this.pageData = JSON.parse(JSON.stringify(this.originalData)); // Reset to original data
        },
      },
    };
  </script>
  
  <style scoped>
  .page-editor {
    margin-top: 40px;
    padding: 20px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 100%;
    margin: 0 auto;
  }
  
  .page-editor h2 {
    font-size: 1.8rem;
    margin-bottom: 20px;
    color: #333;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .btn-save {
    background-color: #007bff;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .btn-save:hover {
    background-color: #0056b3;
  }
  
  .btn-reset {
    background-color: #f5f5f5;
    color: #333;
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .btn-reset:hover {
    background-color: #e5e5e5;
  }
  </style>
  
